module.exports = __webpack_public_path__ + "img/graph-dark.f293d161.png";